<template>
   <!-- Hero Section Start -->
	 <div class="hero bg-image hero-slider">
        <div class="hero-slider-layout">
			<div class="swiper">
				<div class="swiper-wrapper">
					<!-- Hero Slide Start -->
					<div class="swiper-slide">
						<div class="hero-slide">
							<!-- Slider Image Start -->
							<div class="hero-slider-image">
								<img src="https://firebasestorage.googleapis.com/v0/b/usdadental-6e620.appspot.com/o/images%2FImagen%20de%20WhatsApp%202025-01-13%20a%20las%2019.48.59_9d9b954a.jpg?alt=media&token=ffb6882d-8ea1-4c8f-9f39-defc84983368" alt="">
							</div>
							<!-- Slider Image End -->

							<!-- Slider Content Start -->
							<div class="container">
								<div class="row align-items-center">
									<div class="col-lg-12">
										<!-- Hero Content Start -->
                                        <div class="hero-content">
                                            <!-- Section Title Start -->
                                            <div class="section-title">
                                                <h3 class="wow fadeInUp">bienvenidos a USDA Dental</h3>
                                                <h1 class="text-anime-style-2" data-cursor="-opaque">Cuidado dental para toda la familia</h1>
                                                <p class="wow fadeInUp" data-wow-delay="0.25s">En USDA Dental nos dedicamos a ofrecer odontología integral con un enfoque personalizado. Nuestro objetivo es transformar tu salud bucal y realzar tu confianza con tratamientos de calidad y atención excepcional.</p>
                                            </div>
                                            <!-- Section Title End -->
                    
                                            <!-- Hero Content Body Start -->
                                            <div class="hero-content-body wow fadeInUp" data-wow-delay="0.5s">
                                                <a href="https://wa.link/kkyua5" class="btn-default">agendar cita</a>
                                            </div>
                                            <!-- Hero Content Body End -->
                    
                                            <!-- Google Rating Start -->
                                            <div class="google-rating wow fadeInUp" data-wow-delay="0.75s">
                                                <ul>
                                                   <li>Google Rating <span>5.0</span></li>
                                                   <li>
                                                       <i class="fa-solid fa-star"></i>
                                                       <i class="fa-solid fa-star"></i>
                                                       <i class="fa-solid fa-star"></i>
                                                       <i class="fa-solid fa-star"></i>
                                                       <i class="fa-solid fa-star"></i>
                                                   </li>
                                                   <li>based on 1 reviews</li>
                                                </ul>   
                                           </div>
                                           <!-- Google Rating End -->
                                        </div>
                                        <!-- Hero Content End -->
									</div>
								</div>
							</div>
							<!-- Slider Content End -->
						</div>
					</div>
					<!-- Hero Slide End -->

                    <!-- Hero Slide Start -->
					
					<!-- Hero Slide End -->
				</div>
			</div>  
		</div>
    </div>
	<!-- Hero Section End -->
   
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
